import { AuthPage } from '@refinedev/antd';

export function LoginPage() {
  return <AuthPage type="login" registerLink={false} forgotPasswordLink={false} />;
}
